import type { Comment } from '@gobingebox/shared';
import { apiFetch } from '@/lib/api';

export const commentsApi = {
  list: (slug: string) =>
    apiFetch<{ commentsEnabled: boolean; comments: Comment[] }>(`/comments/show/${slug}`),
  post: (slug: string, body: string) =>
    apiFetch<{ comment: Comment; held: boolean }>(`/comments/show/${slug}`, {
      method: 'POST',
      body: JSON.stringify({ body }),
    }),
  react: (id: string, value: 1 | -1 | 0) =>
    apiFetch<{ likes: number; dislikes: number; myReaction: number }>(`/comments/${id}/react`, {
      method: 'POST',
      body: JSON.stringify({ value }),
    }),
  remove: (id: string) => apiFetch<{ ok: boolean }>(`/comments/${id}`, { method: 'DELETE' }),
};
